import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'core-view-terms-and-conditions-modal',
  templateUrl: './view-terms-and-conditions-modal.component.html',
  styleUrls: ['./view-terms-and-conditions-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewTermsAndConditionsModalComponent implements OnDestroy {
  @Input()
  base64!: string;

  @Output()
  closeClick = new EventEmitter<void>();

  isDirty = false;
  language = this.translateService.currentLang;

  private destroyed = new Subject<void>();

  constructor(private translateService: TranslateService) {}

  ngOnDestroy(): void {
    this.destroyed.next();
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
